const actions = {
  CHECK_AUTHORIZATION: 'CHECK_AUTHORIZATION',
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGOUT: 'LOGOUT',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FINISHED: 'LOGIN_FINISHED',
  LOGIN_ERROR: 'LOGIN_ERROR',
  USER_SIGN_UP: 'USER_SIGN_UP',
  SIGN_UP_SUCCESS: 'SIGN_UP_SUCCESS',
  SIGN_UP_ERROR: 'SIGN_UP_ERROR',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  FORGOT_PASSWORD_SUCCESS: 'FORGOT_PASSWORD_SUCCESS',
  FORGOT_PASSWORD_ERROR: 'FORGOT_PASSWORD_ERROR',
  signUp: (firstName, lastName, email, password) => ({
    type: actions.USER_SIGN_UP,
    user: {firstName, lastName, email, password}
  }),
  checkAuthorization: () => ({type: actions.CHECK_AUTHORIZATION}),
  login: (email, password) => ({
    type: actions.LOGIN_REQUEST,
    credentials: {email, password}
  }),
  forgotPassword: (email) => ({
    type: actions.FORGOT_PASSWORD,
    email,
  }),
  logout: () => ({
    type: actions.LOGOUT
  }),
};
export default actions;
